<template>
  <!--
    作者：yangxiaojun
    时间：2020-09-03
    描述：插件中心-供应商设置
  -->
  <div class="user">
     <el-form-item label="开启供应商">
        <div>
          <el-radio v-model="form.is_open" :label="1">开</el-radio>
          <el-radio v-model="form.is_open" :label="0">关</el-radio>
        </div>
      </el-form-item>
      <el-form-item label="允许用户申请">
        <div>
          <el-radio v-model="form.is_apply" :label="1">是</el-radio>
          <el-radio v-model="form.is_apply" :label="0">否</el-radio>
        </div>
      </el-form-item>
      <el-form-item label="商品刷新金币消耗">
        <div>
         <el-input class="max-w460" type="number" min="0" v-model="form.promotion_points" ></el-input>
        </div>
      </el-form-item>
      <el-form-item label="是否需要实名认证">
        <div>
          <el-radio  v-model="form.need_certification" :label="0">不需要</el-radio>
          <el-radio  v-model="form.need_certification" :label="1">实名认证【可不审核】</el-radio>
          <el-radio  v-model="form.need_certification" :label="2">实名认证【必须审核】</el-radio>
        </div>
      </el-form-item>
      
      <el-form-item label="可申请级别">
        <el-select v-model="form.grade" multiple placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.kmd_grade_id"
            :label="item.name"
            :value="item.kmd_grade_id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="申请广告图">
        <div class="d-c-c ad-picture" @click="openUpload(2)">
        <img v-if="form.banner_image_id > 0" :src="form.banner_file_path" width="300" height="124" />
        <span v-else class="el-icon-picture-outline"></span>
      </div>
      <p class="ml10 gray">提示：图片尺寸建议750x310</p>
      </el-form-item>
      <el-form-item label="申请说明">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload(0)">选择图片</el-button>
          <div v-if="form.image_id!=''" class="img">
            <img :src="form.file_path" width="100" height="100" />
          </div>
        </el-row>
         <p class="gray">建议宽度750px，高度不限，建议小于500K</p>
      </el-form-item>
    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
  </div>
</template>
<script>
// import SupplyApi from '@/api/supply.js';
import Upload from '@/components/file/Upload';
export default {
  components: {
    /*选择商品组件*/
    Upload,
  },
  
  data() {
    return {
       /*是否上传图片*/
      isupload: false,
      
    };
  },
  props: {
    form: Object,
    options: Array
  },
  methods: {
    // 上传
     openUpload(e) {
      this.isupload = true;
      this.uploadtype= e;
    },
      /*获取图片*/
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        if(this.uploadtype==0){
          this.form.file_path = e[0].file_path;
          this.form.image_id = e[0].file_id;
        }else{
          this.form.banner_file_path = e[0].file_path;
           this.form.banner_image_id = e[0].file_id;
        }
        
      }
      this.isupload = false;
    },
  }
  
};
</script>

<style>
.ad-picture {
  width: 300px;
  height: 124px;
  border-radius: 16px;
  font-size: 40px;
  border: 1px dashed #cccccc;
  color: $blue;
  cursor: pointer;
  overflow: hidden;
}
 .ad-picture:hover {
  border: 1px dashed $blue;
}

 .ad-picture img {
  object-fit: fill;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/supply/setting/part/Basic.vue